<template>
  <div id="app">
    <!--导航条-->
    <gheader type="home"></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav type="home"></grednav>
    <!--登录一行-->
    <div id="carousel-generic" class="row-login carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carousel-generic" data-slide-to="0" class="active"></li>
        <li data-target="#carousel-generic" data-slide-to="1"></li>
      </ol>
      <div class="set-position" style="width: 100%;max-width: 1200px;margin: 0 auto;">
        <div class="log-in">
          <div>
            <p>{{welcome}}</p>
            <button class="form-control btn btn-login action" @click="login">立即登录</button>
            <!--<a-->
            <!--href="javascript:;" @click="enterlink" id="supply-register">-->
            <a
              href="agreement.html?register"
              target="_blank"
              class="form-control btn btn-default btn-apply"
            >供应商注册</a>
            <!--</a>-->
            <p>
              <a href="agreement.html?register" target="_blank">还没有账号?</a>
              <!--&nbsp;|&nbsp;<a-->
              <!--href="#">忘记密码?</a>-->
            </p>
          </div>
          <hr />
          <div style="margin-top: 5px">
            <h5 style="display: inline-block">
              <img src="static/imgs/helpCenter.png" alt />&nbsp;帮助中心
            </h5>
            <p style="display: inline-block;float:right">
              <a href="manual.html" target="_blank">供应商操作手册</a>
            </p>
          </div>
        </div>
      </div>
      <div
        class="carousel-inner"
        role="listbox"
        id="getOnfocus"
        v-for="(item, $index) in bannerList"
      >
        <div class="item active">
          <div class="carousel-bg carousel-bg-jsqp2"></div>
        </div>
        <div class="item">
          <div class="carousel-bg carousel-bg-jsqp3"></div>
        </div>
      </div>
    </div>
    <!--主要内容展示-->
    <div class="row-content" style="overflow-x: auto">
      <div class="main-width">
        <div class="bid-info pull-left">
          <div class="form-group">
            <infotable
              class="table-latest"
              v-bind:tableTitle="tableTitle[0]"
              v-bind:tableContent="tableContent['latest']"
              v-bind:which="tableType[0]"
            ></infotable>
          </div>
          <!--        <div class="form-group">
            <infotable class="table-area" datatype="area" :tableTitle="tableTitle[1]"
                       v-bind:tableContent="tableContent['area']"
                       v-bind:which="tableType[1]"
            ></infotable>
          </div>-->
          <div class="form-group">
            <infotable
              class="table-type"
              data-type="type"
              v-bind:tableTitle="tableTitle[2]"
              v-bind:tableContent="tableContent['type']"
              v-bind:which="tableType[2]"
            ></infotable>
          </div>
          <div class="form-group">
            <infotable
              class="table-orgName"
              data-type="orgName"
              v-bind:tableTitle="tableTitle[3]"
              v-bind:tableContent="tableContent['orgName']"
              v-bind:which="tableType[0]"
            ></infotable>
          </div>
        </div>
        <div class="bid-notice pull-right">
          <div class="form-group">
            <notice type="bidding" :apiUrl="noticeUrl[1]" :num="2"></notice>
          </div>
          <div class="form-group">
            <notice type="company" :apiUrl="noticeUrl[0]" :ajaxType="'get'" :morelink="moreLink[0]"></notice>
          </div>
          <div class="form-group">
            <notice type="lbnotice" :apiUrl="noticeUrl[3]" :morelink="moreLink[1]"></notice>
          </div>
          <div class="form-group">
            <notice type="cqnotice" :apiUrl="noticeUrl[4]" :morelink="moreLink[2]"></notice>
          </div>
          <!--<div class="form-group">-->
          <!--<notice type="links" id="notice-links"></notice>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <!--注册流程-->
    <regflows></regflows>
    <!--合作供应商-->
    <!-- <gsupplier></gsupplier> -->
    <!--footer-->
    <gfooter></gfooter>
  </div>
</template>

<script>
/*eslint-disable*/
import gheader from 'components/G-header'
import glogo from 'components/G-logo'
import grednav from 'components/G-rednav'
import regflows from 'components/reg-flows'
import gsupplier from 'components/G-supplier'
import gfooter from 'components/G-footer'
import notice from 'components/notice'
import infotable from 'components/info-table'
import { apiLinks } from 'src/api/links.js'

export default {
  name: 'app',
  components: {
    gheader,
    glogo,
    grednav,
    regflows,
    gsupplier,
    gfooter,
    notice,
    infotable
  },
  data () {
    return {
      bannerList: apiLinks.bannerList,
      cashome: '/yuncai/portal',
      apiUrl: '',
      applylink: '',
      southCement: apiLinks.southCement['home'],
      tableTitle: [
        '最新采购信息',
        '按区域查看',
        '按类别查看',
        '按采购组织'
      ],
      tableContent: {
        latest: [
          '最新项目'
        ],
        area: [
          '全部',
          '上海',
          '浙江',
          '江西',
          '湖南',
          '广西',
          '江苏',
          '安徽',
          '福建'
        ],
        type: [
          '全部'
        ],
        orgName: [
          '全部'
        ]
      },
      tableType: [
        'latest',
        'area',
        'type',
        'orgName'
      ],
      noticeUrl: [
        apiLinks.notice['company'],
        apiLinks.notice['bidding'],
        '2',
        apiLinks.notice['lbnotice'],
        apiLinks.notice['cqnotice']
      ],
      welcome: apiLinks.welcome,
      moreLink: [
        apiLinks.details.noticeMore,
        apiLinks.details.lbnoticeMore,
        apiLinks.details.cqnoticeMore
      ]
    }
  },
  methods: {
    login: function () {
      let href = window.location.href
      if (href.indexOf('localhost') > 0) {
        window.location.href = '/yuncai/mobile/login.html?r=/home.html'
      } else if (href.indexOf('yc.yonyou.com') > 0) {
        window.location.href = '/yuncai/portal'
      } else {
        window.location.href = 'https://euc.yonyoucloud.com/cas/login?sysid=ipu&ipuid=' + apiLinks.portaltype + '&service=https%3A%2F%2Fyc.yonyoucloud.com%2Fyuncai%2FSSO%2Flogin.jsp%3Fr%3DL3l1bmNhaS9wb3J0YWw'
      }
    },
    enterlink: function () {
      let str = apiLinks.register
      this.applylink = str
    }
  },
  mounted: function () {
    this.enterlink()
    window.localStorage.setItem('portaltype', apiLinks.portaltype)
    window.localStorage.setItem('privateportal', 'yuncai')
    if (window.document.cookie.indexOf('tenantid') >= 0) {
      window.location.href = './cashome.html'
    }
  }
}
</script>
<style lang="less">
@import "home.less";
</style>



// WEBPACK FOOTER //
// home.vue?650619d8